import { AbstractControl } from "@angular/forms";
import { createPostalCodeMask } from "@ui/input-masks";

export const brazilianStates = [
    { title: "Acre", id: "AC" },
    { title: "Alagoas", id: "AL" },
    { title: "Amapá", id: "AP" },
    { title: "Amazonas", id: "AM" },
    { title: "Bahia", id: "BA" },
    { title: "Ceará", id: "CE" },
    { title: "Distrito Federal", id: "DF" },
    { title: "Espírito Santo", id: "ES" },
    { title: "Goiás", id: "GO" },
    { title: "Maranhão", id: "MA" },
    { title: "Mato Grosso", id: "MT" },
    { title: "Mato Grosso do Sul", id: "MS" },
    { title: "Minas Gerais", id: "MG" },
    { title: "Pará", id: "PA" },
    { title: "Paraíba", id: "PB" },
    { title: "Paraná", id: "PR" },
    { title: "Pernambuco", id: "PE" },
    { title: "Piauí", id: "PI" },
    { title: "Rio de Janeiro", id: "RJ" },
    { title: "Rio Grande do Norte", id: "RN" },
    { title: "Rio Grande do Sul", id: "RS" },
    { title: "Rondônia", id: "RO" },
    { title: "Roraima", id: "RR" },
    { title: "Santa Catarina", id: "SC" },
    { title: "São Paulo", id: "SP" },
    { title: "Sergipe", id: "SE" },
    { title: "Tocantins", id: "TO" },
];

export const brazilianStateValidator = (control: AbstractControl) => {
    const state = control.value;

    if (state === null) return null;

    if (typeof state !== "string") {
        return { stateValidator: `state should be string, but found ${typeof state}` };
    }

    if (!brazilianStates.some(({ id }) => id.toLocaleUpperCase() === state.toLocaleUpperCase())) {
        return {
            stateValidator: `state should be a valid Brazilian state, but found ${state}`,
        };
    }

    return null;
};

const cepRegex = /\d{5}-\d{3}/;
export const cepValidator = (control: AbstractControl) => {
    const mask = createPostalCodeMask();
    mask.value = `${control.value}`;
    const value = mask.value;

    if (cepRegex.test(value)) {
        return null;
    }

    return {
        cepValidator: `expected CEP to fit XXXXX-XXX number format, but "${value}" found`,
    };
};
